import Logo1 from "../../../assets/images/logo1.png";
import Logo2 from "../../../assets/images/logo2.svg";
import { useSelector } from "react-redux";
import moment from "moment";
import { useMemo } from "react";

const SalesAdjustmentReportHeader = () => {
  const { salesAdjustmentPrint } = useSelector((state) => state);
  const headerData = salesAdjustmentPrint && salesAdjustmentPrint?.payload?.data[0];
  const brand = useMemo(() => new URLSearchParams(window.location.search).get("brand"), []);
  const _logo = brand === "DL1961" ? Logo1 : Logo2;

  return (
    <div className="__header">
      <table width="100%">
        <tbody>
          <tr>
            <td width="65%" style={{ paddingRight: "5px" }}>
              <table width="100%">
                <tbody>
                  <tr>
                    <td colSpan={2}>
                      <table width="100%">
                        <tbody>
                          <tr>
                            <td>
                              <div className="__image_container">
                                <img width={250} height={72} src={_logo} alt="Brand Logo" />
                              </div>
                            </td>
                            <td valign="top" width="100%">
                              <div className="__addr">
                                <p>DLPD CANADA LTD.</p>
                                <p>15 Wertheim Court, Suite 409,</p>
                                <p>Richmond Hill, ON L4B 3H7 , Canada</p>
                                <p>Business # : 763395530RT0001</p>
                                <p>Email : orderca@dl1961.com</p>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td width="50%" valign="top" style={{ paddingRight: "5px" }}>
                      <table width="100%" className="__addr_table">
                        <tbody>
                          <tr>
                            <td valign="top">Sold To :</td>
                            <td colSpan={3}>{headerData?.bill_to_customer || ''}</td>
                          </tr>
                          <tr>
                            <td valign="top">Name :</td>
                            <td colSpan={3}>{(headerData?.billing_firstname) ? headerData?.billing_firstname + ' ' + headerData.billing_lastname : headerData?.customer_name}</td>
                          </tr>
                          <tr>
                            <td valign="top">Address 1 :</td>
                            <td colSpan={3}>{headerData?.bill_to_address_1 || ''}</td>
                          </tr>
                          <tr>
                            <td valign="top">Address 2 :</td>
                            <td colSpan={3}>{headerData?.bill_to_address_2 || ''}</td>
                          </tr>
                          <tr>
                            <td valign="top">City :</td>
                            <td>{headerData?.bill_to_city_name || ''}</td>
                            <td valign="top">State :</td>
                            <td>{headerData?.bill_to_state_name || ''}</td>
                          </tr>
                          <tr>
                            <td valign="top">Country :</td>
                            <td>{headerData?.bill_to_country || ''}</td>
                            <td valign="top">ZIP :</td>
                            <td>{headerData?.bill_to_zip || ''}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td width="50%" style={{ paddingLeft: "5px" }}>
                      <table width="100%" className="__addr_table">
                        <tbody>
                          <tr>
                            <td valign="top">Ship To :</td>
                            <td colSpan={5}>{headerData?.ship_to_addressee || ''}</td>
                          </tr>
                          <tr>
                            <td valign="top">Name :</td>
                            <td colSpan={5}>
                              {(headerData?.shipping_firstname) ? headerData?.shipping_firstname + ' ' + headerData.shipping_lastname : headerData?.customer_name}
                            </td>
                          </tr>
                          <tr>
                            <td valign="top">Address 1 :</td>
                            <td colSpan={5}>{headerData?.ship_to_address_1 || ''}</td>
                          </tr>
                          <tr>
                            <td valign="top">Address 2 :</td>
                            <td colSpan={5}>{headerData?.ship_to_address_2 || ''}</td>
                          </tr>
                          <tr>
                            <td valign="top">City :</td>
                            <td>{headerData?.ship_to_city_name || ''}</td>
                            <td valign="top">State :</td>
                            <td>{headerData?.ship_to_state_name || ''}</td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr>
                            <td valign="top">Country :</td>
                            <td>{headerData?.ship_to_country_name || ''}</td>
                            <td valign="top">ZIP :</td>
                            <td>{headerData?.ship_to_zip || ''}</td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr>
                            <td valign="top">Dept :</td>
                            <td>{headerData?.department || ''}</td>
                            <td valign="top">DC # :</td>
                            <td>{headerData?.dc_no || ''}</td>
                            <td valign="top">Store :</td>
                            <td>{headerData?.store_name || ''}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td valign="top" width="35%" style={{ paddingLeft: "5px" }}>
              <table width="100%" className="__box">
                <tbody>
                  <tr>
                    <td colSpan={2} className="__heading" align="center">Sale Order Adjustment
                    </td>
                  </tr>
                  <tr>
                    <td width="40%" valign="top">Adjustment # :</td>
                    <td>
                      {headerData && headerData.adj_no || ''}
                    </td>
                  </tr>
                  <tr>
                    <td valign="top">Adjustment Date :</td>
                    <td>
                      {headerData && moment(headerData.order_date).format("MM-DD-YYYY")}
                    </td>
                  </tr>
                  <tr>
                    <td valign="top">P.O # :</td>
                    <td>
                      {headerData?.po_number || ''}
                    </td>
                  </tr>
                  <tr>
                    <td valign="top">Sale Order # :</td>
                    <td>
                      {headerData?.sale_order_no || ''}
                    </td>
                  </tr>
                  <tr>
                    <td valign="top">Term :</td>
                    <td>
                      {headerData?.term || ''}
                    </td>
                  </tr>
                  <tr>
                    <td valign="top">Ship Via :</td>
                    <td>
                      {headerData?.ship_via || ''}
                    </td>
                  </tr>
                  <tr>
                    <td valign="top">Freight Terms :</td>
                    <td>
                      {headerData?.frieght_terms || ''}
                    </td>
                  </tr>
                  <tr>
                    <td valign="top">Ship Date(From) :</td>
                    <td>
                      {headerData && moment(headerData.ship_date_from).format("MM-DD-YYYY")}
                    </td>
                  </tr>
                  <tr>
                    <td valign="top">Ship Date(To) :</td>
                    <td>
                      {headerData && moment(headerData.cancel_date).format("MM-DD-YYYY")}
                    </td>
                  </tr>
                  <tr>
                    <td valign="top">Cancel Date :</td>
                    <td>
                      {headerData && moment(headerData.cancel_date).format("MM-DD-YYYY")}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default SalesAdjustmentReportHeader;
